"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getISODate = void 0;
const get_ISO_date_time_1 = require("../get-ISO-date-time/get-ISO-date-time");
/**
 * Get date in ISO format yyyy-MM-dd
 * @public
 *
 * @param date - Date to convert
 *
 * @returns Date in ISO format yyyy-MM-dd or undefined
 *
 * @example
 * ```ts
 * const isoDate = getISODate(new Date(2021, 11, 25))
 * console.log(isoDate);
 * // -> '2021-11-25T22:44:07.978'
 * ```
 */
function getISODate(date) {
    const isoDateTime = (0, get_ISO_date_time_1.getISODateTime)(date);
    return isoDateTime ? isoDateTime.split('T')[0] : undefined;
}
exports.getISODate = getISODate;
//# sourceMappingURL=get-ISO-date.js.map